// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"88e5dc84","483":"0a4b453e","956":"e86f7ef3"}[chunkId] + ".chunk.js";
};